module.exports = __webpack_public_path__ + "static/img/logo_yt.4529463.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010221/logo_yt.png
// module id = 9gIO
// module chunks = 10